/**
 * 보스 예약 주문(pack order) 관련 쿼리·뮤테이션.
 * pre-order/sales, pre-order-list, live-order 등에서 재사용.
 */
import { gql } from "@apollo/client";
import type { Order } from "../../../__generated__/graphql";
import type { FilterStatus } from "../pre-order/components/filter-status-chip";

export const GET_PACK_ORDERS = gql`
  query GetPackOrdersBySeller {
    packOrdersBySeller {
      id
      packPickupStartTime
      packPickupEndTime
      pack {
        name
        price
        discountPrice
        store {
          reserveTime
        }
      }
      user {
        id
        name
        phone
      }
      totalQuantity
      createdAt
      isPackConfirmed
      isCanceled
      cancelReason
      identificationCode
      isPickupCompleted
      packPickupStartTime
    }
  }
`;

export const GET_PACK_ORDERS_TODAY_TOMORROW = gql`
  query GetPackOrdersBySellerTodayTomorrow {
    packOrdersBySellerTodayTomorrow {
      id
      packPickupStartTime
      packPickupEndTime
      pack {
        name
        price
        discountPrice
        store {
          reserveTime
        }
      }
      user {
        id
        name
        phone
      }
      totalQuantity
      createdAt
      isPackConfirmed
      isCanceled
      cancelReason
      identificationCode
      isPickupCompleted
      packPickupStartTime
    }
  }
`;

export const CREATE_REPORT = gql`
  mutation CreateReport($orderId: Int!, $reason: String!) {
    createReport(orderId: $orderId, reason: $reason) {
      ok
      error
    }
  }
`;

export const ORDER_FILTERS: Record<
  FilterStatus,
  (order: Order) => boolean | null | undefined
> = {
  ALL: () => true,
  PENDING: (order) => !order.isPackConfirmed && !order.isCanceled,
  CONFIRMED: (order) => order.isPackConfirmed && !order.isCanceled,
};
